// Import mock entities (for entities not yet in backend)
import {
  Provider as MockProvider,
  Transaction as MockTransaction,
  WebhookLog as MockWebhookLog,
  RoutingRule as MockRoutingRule,
  AuditLog as MockAuditLog,
  Settlement as MockSettlement,
} from './mockEntities';

// Import real entities (from backend GraphQL API)
import {
  Merchant as RealMerchant,
  Reseller as RealReseller,
  Engine as RealEngine,
  Admin as RealAdmin,
} from './mockEntities';

// Import auth
import { auth } from './graphqlClient';

// Export mock entities
export const Provider = MockProvider;
export const Transaction = MockTransaction;
export const WebhookLog = MockWebhookLog;
export const RoutingRule = MockRoutingRule;
export const AuditLog = MockAuditLog;
export const Settlement = MockSettlement;

// Export real entities
export const Merchant = RealMerchant;
export const Reseller = RealReseller;
export const Engine = RealEngine;
export const Admin = RealAdmin;

// Export auth as User for backward compatibility
export const User = auth;